const INDUSTRY_CERTIFICATION_EXAM_QUALIFIED_CERT_SLUGS = [
  'arizona-state-university-tesol',
  'aws-cloud-solutions-architect ',
  'certified-artificial-intelligence-practitioner',
  'certified-data-science-practitioner',
  'certified-ethical-emerging-technologist',
  'tensorflow-in-practice',
  'icpm-certified-supervisor',
  'microsoft-azure-dp-203-data-engineering',
  'azure-data-scientist',
  'azure-developer-associate',
  'palo-alto-networks-cybersecurity-fundamentals',
  'gcp-cloud-architect',
  'gcp-cloud-architect-jp',
  'gcp-data-engineering',
  'gcp-data-engineering-jp',
  'google-cloud-developer',
  'sre-devops-engineer-google-cloud',
  'cloud-engineering-gcp',
  'google-cloud-networking',
  'google-cloud-security',
  'preparing-for-google-cloud-machine-learning-engineer-professional-certificate',
  'sas-advanced-programmer',
  'sas-programming',
  'sas-statistical-business-analyst',
  'sas-visual-business-analytics',
  'google-it-pt2',
  'certificado-it-pt2',
  'gestion-de-projet-de-google',
  'certificat-gestion-de-projet',
  'gestion-de-proyectos-de-google',
  'certificado-gestion-de-proyectos',
  'google-it-de',
  'it-certificate-de',
  'google-it-support',
  'support-informatique-google',
  'it-support-certificate',
  'certificat-support-informatique',
  'google-proje-yonetimi',
  'sertifika-proje-yonetimi',
  'google-project-management-de',
  'project-management-certificate-de',
  'gestao-de-projetos-do-google',
  'certificado-gestao-de-projetos',
  'gestion-de-projet-google',
  'certificat-gestion-de-projet-fr',
  'google-project-management',
  'project-management-certificate',
  'google-it-arabic',
  'it-certificate-arabic',
  'hubspot-sales-representative',
  'intuit-bookkeeping',
  'sertifikat-it-support-profesional-google',
  'sertifikat-it-support-profesional',
  'google-it-support-ua',
  'it-support-certificate-ua',
  'google-it-ru',
  'it-certificate-ru',
  'marketing-de-midias-sociais-do-facebook',
  'marketing-en-redes-sociales-de-facebook',
  'facebook-marketing-analytics',
  'facebook-social-media-marketing',
  'soporte-de-tecnologias-de-informacion-google',
  'certificado-soporte-de-tecnologias-de-informacion',
  'soutien-des-ti-de-google',
  'certificat-soutien-des-ti',
  'suporte-em-ti-do-google',
  'certificado-suporte-em-ti',
  'google-project-management-arabic',
  'project-management-certificate-arabic',
  'al-tasweeq-aabr-wasael-al-tawasol-al-ijtimai',
];

export default INDUSTRY_CERTIFICATION_EXAM_QUALIFIED_CERT_SLUGS;
